import { ComponentProps, FC, ReactNode, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Dialog, DialogNames } from '@/_shared/components/Dialog';
import { Routes } from '@/_shared/constants';

type BlockingDialogProps = {
  name: DialogNames;
  open: boolean;
  children: ReactNode;
  dialogProps?: Omit<ComponentProps<typeof Dialog>, 'children' | 'name'>;
};

const noop = () => {};

export const BlockingDialog: FC<BlockingDialogProps> = ({ name, open, dialogProps, children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // While a blocking dialog is open, force the user back to Homepage on every
  // route change so they cannot reach any other page until the issue is solved.
  useEffect(() => {
    if (open && location.pathname !== Routes.Homepage) {
      navigate(Routes.Homepage, { replace: true });
    }
  }, [open, location.pathname, navigate]);

  return (
    <Dialog
      name={name}
      open={open}
      closeButton={false}
      avoidCloseOnBackDrop
      onClose={noop}
      maxWidth='600px'
      backDropStyle={{
        style: {
          backdropFilter: 'blur(8px)',
          WebkitBackdropFilter: 'blur(8px)',
        },
      }}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...dialogProps}
    >
      {children}
    </Dialog>
  );
};
